










import {Component, Vue} from 'vue-property-decorator';
import {ModuleAuth} from '@/store/modules/AuthModule';

@Component({})
export default class LogoutBtn extends Vue {

  async logout() {
    ModuleAuth.logout();
    await this.$router.push({name: 'auth.login'});
  }
}
